import React, { useState, useEffect } from 'react';
import api from '../services/api';

const ConnectionStatus = () => {
  const [status, setStatus] = useState('checking');

  const checkConnection = async () => {
    try {
      // Adding a timestamp to prevent caching
      const timestamp = new Date().getTime();
      
      // Get the base URL from environment
      const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
      console.log('ConnectionStatus: Using baseURL:', baseURL);
      
      // The backend routes are prefixed with /api in server.js
      const healthEndpoint = '/api/health';
      console.log('ConnectionStatus: Using healthEndpoint:', healthEndpoint);
      
      // Construct the full URL - ensure we have the correct path
      const fullUrl = `${baseURL}/api/health?t=${timestamp}`;
      console.log('ConnectionStatus: Making request to:', fullUrl);
      
      // Make direct fetch request
      const response = await fetch(fullUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
      });
      
      console.log('ConnectionStatus: Response status:', response.status);
      
      if (response.ok) {
        console.log('ConnectionStatus: API connected successfully');
        setStatus('connected');
      } else {
        console.log('ConnectionStatus: API connection failed with status:', response.status);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error('ConnectionStatus: API connection check failed:', error);
      setStatus('disconnected');
    }
  };

  useEffect(() => {
    // Check connection when component mounts
    checkConnection();

    // Set up interval to check connection every 30 seconds
    const intervalId = setInterval(checkConnection, 30000);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // Determine the color of the dot based on connection status
  const dotColor = status === 'connected' ? '#28a745' : // green
                  status === 'disconnected' ? '#dc3545' : // red
                  '#6c757d'; // gray for checking

  return (
    <div className="connection-status" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
      <div 
        className="status-dot" 
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: dotColor,
          display: 'inline-block'
        }}
        title={status === 'connected' ? 'API Connected' : 
              status === 'disconnected' ? 'API Disconnected' : 
              'Checking API Connection'}
      />
    </div>
  );
};

export default ConnectionStatus;
